import { ColorEnum } from '@enum/style/color.enum';

import { TableStyleType } from './table-style.interface';

export const TableDarkTheme: TableStyleType = {
  colorPrimary: ColorEnum.Teal100,
  colorHeaderBorder: ColorEnum.Black30,
};
